import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ContextService } from '../services/context.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard  {
  constructor(
    private router: Router,
    private contextService: ContextService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.contextService.isLoggedIn()) {
      return true;
    } else {
      this.urlFromEmail(); 
      this.router.navigateByUrl('/autenticacao');
    }
  }

  urlFromEmail() { // Salva URL para usuários que vierem do Email.
    let url = window.location.pathname;
    sessionStorage.setItem('urlFromEmail', url);
  }
}
